import { render, staticRenderFns } from "./settingAddress.vue?vue&type=template&id=e20ed31e&scoped=true"
import script from "./settingAddress.vue?vue&type=script&lang=js"
export * from "./settingAddress.vue?vue&type=script&lang=js"
import style0 from "./settingAddress.vue?vue&type=style&index=0&id=e20ed31e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20ed31e",
  null
  
)

export default component.exports